import PageHero from '@/components/feature/PageHero';

export default function ConsumptionHero() {
  return (
    <PageHero
      eyebrow="九畴云铺 · 消费端样板"
      title="九畴云铺消费体验"
      titleHighlight="聚餐场景 · 权益系统"
      desc="把 AI、权益、餐饮、社交、消费和数据真正跑起来，让投资人看到九畴云铺不是一个抽象平台，而是一套可真实运转的消费引擎。"
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20warm%20dining%20and%20consumption%20scene%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20coupon%20and%20red%20packet%20light%20elements%20connecting%20social%20dining%20nodes%2C%20rural%20digital%20economy%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=jiuchou-consume-01&orientation=landscape"
      imageAlt="九畴云铺 聚餐场景与权益系统"
      imageTitle="九畴云铺 消费体验"
    />
  );
}